export const DeclarationsTreeViewName = 'declarationsTreeViewNameComponent';
